import { useMemo } from 'react';
import apiClient from 'src/api/axiosClient';
import {
  CreateAdminPlanRequestData,
  GetAdminPlansParams,
  Plan,
  UpdateAdminPlanRequestData,
} from '../types';

export function usePlansApi() {
  return useMemo(
    () => ({
      getAdminPlans: (params: GetAdminPlansParams) => {
        return apiClient.get<{ items: Plan[]; count: number }>(`/plans`, { params });
      },

      createAdminPlan: (data: CreateAdminPlanRequestData) => {
        return apiClient.post<Plan>(`/plans`, data);
      },

      updateAdminPlan: (planId: string, data: UpdateAdminPlanRequestData) => {
        return apiClient.put<void>(`plans/${planId}`, data);
      },

      archiveAdminPlan: (planId: string) => {
        return apiClient.delete<void>(`plans/${planId}`);
      },

      unarchiveAdminPlan: (planId: string) => {
        return apiClient.patch<void>(`plans/${planId}`, { status: 'active' });
      },
    }),
    [],
  );
}
